<template>
<div>
    <dialogWrap
        v-model="dialogShow"
        title="开通进度"
        width="900px"
    >
        <div class="progress-container">
            <div class="statistics">
                <div class="header">数据统计</div>
                <div class="statistics-content">
                    <div class="progress-statistics">
                        <div class="data-row">
                            <div class="data-label">开通中（条）</div>
                            <div class="data-value">{{ staticsData.openingNum }}</div>
                        </div>
                        <div class="data-row">
                            <div class="data-label">
                                已驳回（条）
                                <el-tooltip
                                    effect="dark" content="未审核通过开通子户的申请，具体驳回原因可查看开通明细，如下列表" placement="top">
                                    <i class="el-icon-info"></i>
                                </el-tooltip>
                            </div>
                            <div class="data-value">{{ staticsData.rejectedNum }}</div>
                        </div>
                    </div>
                    <div class="progress-statistics">
                        <div class="data-row">
                            <div class="data-label">
                                待启用（条）
                                <el-tooltip
                                    effect="dark" content="子户已开通成功需操作启用该子户" placement="top">
                                    <i class="el-icon-info"></i>
                                </el-tooltip>
                            </div>
                            <div class="data-value">
                                <span
                                    style="margin-right: 8px;"
                                >
                                    {{ staticsData.toEnableNum }}
                                </span>
                                <el-button type="text" @click="goToWithholdConfig">去启用</el-button>
                            </div>
                        </div>
                        <div class="data-row">
                            <div class="data-label">待e签宝授权
                                <el-tooltip
                                    effect="dark" content="线上签署需要完成e签宝印章的授权" placement="top">
                                    <i class="el-icon-info"></i>
                                </el-tooltip>
                            </div>
                            <div class="data-value">
                                <span style="margin-right: 8px;"
                                >{{ staticsData.toAuthorizeNum }}
                                </span>
                                <el-button type="text" @click="goToESigConfig">去授权</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="opening-list">
                <div class="header">开通明细</div>
                <el-table class="table-container" v-loading="tableLoading" :data="tableData">
                    <el-table-column
                        prop="corporationName"
                        label="开通主体"
                    ></el-table-column>
                    <el-table-column
                        prop="auditState"
                        label="开通状态"
                    >
                        <template slot-scope="scope">
                            <el-tag
                                :type="
                                    scope.row.auditState === AUDIT_STATE_ENUM.REJECTED
                                    ? 'danger' : 'success'"
                            >
                                {{ auditList[scope.row.auditState] }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="rejectReason" label="驳回原因">
                        <template slot-scope="scope">
                            <el-tooltip
                                :content="scope.row.rejectReason"
                                v-if="scope.row.rejectReason"
                            >
                                <span class="reject-reason">
                                    {{ scope.row.rejectReason || '--'  }}
                                </span>
                            </el-tooltip>
                        </template>>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text"
                            @click="
                            handleDetail(
                                scope.row.id,
                                scope.row.auditState
                            )">
                                {{ scope.row.auditState === AUDIT_STATE_ENUM.REJECTED
                                    ? '修改' : '详情'
                                }}
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </dialogWrap>
    <OpenWalletWithhold ref="openWalletWithholdRef" />
</div>
</template>

<script setup>
import { getWithholdOpeningList, getWithholdOpeningStatics } from '@/api/domain/dashBoard'
import { useRouter } from '@/utils/useUtils'
import { getCurrentInstance, ref } from 'vue'
import OpenWalletWithhold from '../OpenWalletWithhold/index.vue'

const vm = getCurrentInstance().proxy
const router = useRouter()

const AUDIT_STATE_ENUM = {
  PENDING_APPROVAL: 10, // 待审批
  WITHDRAWN: 20, // 撤回
  REJECTED: 30, // 驳回
  APPROVED: 40, // 审核通过
}

const auditList = {
  [AUDIT_STATE_ENUM.PENDING_APPROVAL]: '待审批',
  [AUDIT_STATE_ENUM.WITHDRAWN]: '已撤回',
  [AUDIT_STATE_ENUM.REJECTED]: '已驳回',
  [AUDIT_STATE_ENUM.APPROVED]: '已通过',
}

const dialogShow = ref(false)
const tableLoading = ref(false)
const openWalletWithholdRef = ref(null)

const tableData = ref([])
const staticsData = ref({
  openingNum: 0,
  rejectedNum: 0,
  toEnableNum: 0,
  toAuthorizeNum: 0,
})

const getList = async () => {
  tableLoading.value = true
  const [err, _data] = await vm.$to(getWithholdOpeningList())
  if (!err) {
    const { code, data } = _data
    if (code === 1) {
      tableData.value = data
    }
  }
  tableLoading.value = false
}

const getStatics = async () => {
  const [err, _data] = await vm.$to(getWithholdOpeningStatics())
  if (!err) {
    const { code, data } = _data
    if (code === 1) {
      staticsData.value = data
    }
  }
}

const handleDetail = (id, auditState) => {
  let mode = 'view'
  dialogShow.value = false

  if (auditState === AUDIT_STATE_ENUM.REJECTED) {
    mode = 'edit'
  }
  openWalletWithholdRef.value.showDrawer(id, mode)
}

const goToWithholdConfig = () => {
  dialogShow.value = false
  router.push({
    path: '/finance/withholdingConfig',
  })
}

const goToESigConfig = () => {
  dialogShow.value = false
  router.push({
    path: '/tenant/eSign/config/list',
  })
}

const showDialog = () => {
  getStatics()
  getList()
  dialogShow.value = true
}

defineExpose({
  showDialog,
})

</script>

<style lang="scss" scoped>
.progress-container {
    .header {
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
        color: rgba(0, 0, 0, 0.9);
    }
    .statistics-content {
        display: flex;
        gap: 16px;
        margin-top: 13px;
        .progress-statistics {
            flex: 1;
            display: flex;
            padding: 20px 16px 0 16px;
            height: 93px;
            background:  #F3F3F4;
            border-radius: 12px;
            .data-row {
                flex: 1;
                .data-label {
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 22px;
                    color: rgba(0, 0, 0, 0.6);
                }
                .data-value {
                    display: flex;
                    font-size: 28px;
                    font-weight: 500;
                    line-height: 36px;
                    color: rgba(0, 0, 0, 0.9);
                }
            }
        }
    }
    .opening-list {
        margin-top: 37px;
        .table-container {
            margin-top: 13px;
            border-radius: 8px;
            border: 1px solid #E7E8EB;
            .reject-reason {
                display: inline-block;
                width: 100px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
}
</style>
